import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import AttachedImages from '../AttachedImages';

import Button from "UI/Button";
import TextArea from "UI/Form/TextArea";

import { facebookPostValidation as validate } from "Data/posts/PostValidators";
import Form from "Components/Form";
import Modal from "UI/Modal";

const defaultState = ({post}) => ({
    busy: false,
    post: post
});

export default class FacebookPostEditor extends React.Component
{
    static propTypes = {
        open: PropTypes.bool.isRequired,
        onClose: PropTypes.func.isRequired,

        post: PropTypes.object.isRequired,
        editPost: PropTypes.func.isRequired,
        removeImage: PropTypes.func.isRequired,
    };

    constructor(props)
    {
        super(props);

        this.state = defaultState(props);
    }

    onClose = (e) => {
        e.preventDefault();

        this.setState(defaultState(this.props));
        this.props.onClose();
    }

    onSubmit = data => {

        this.setState({busy: true}, () => {
            Promise.all([
                this.props.editPost(
                    this.props.post.id,
                    data.message,
                    this.state.post.media
                ),
            ]).then(() => {
                this.setState({busy: false}, this.props.onClose);
            }).catch(() => {
                this.setState({busy: false});
            });
        });
    };

    onAddPostMedia = (mediaId) => {
        const post = { ...this.state.post };
        post.media.push(mediaId);

        this.setState({
            ...this.state,
            post: post
        });
    };

    onRemovePostMedia = (mediaId) => {
        const post = { ...this.state.post };
        post.media = post.media.filter(item => item !== mediaId);

        this.setState({
            ...this.state,
            post: post
        });
    };

    render()
    {
        const { open, onClose } = this.props;

        const media = this.state.post.media.map(uuid => this.props.media[uuid]);

        const defaults = {
            message: this.props.post.message
        };

        return <Modal open={open} onClose={this.onClose} className='w-full max-w-xl'>
            <Modal.Header>
                Edit Facebook Post
            </Modal.Header>
            <Modal.Content>
                <Form id='post-editor' defaults={defaults} validate={validate} onSubmit={this.onSubmit}>
                    {(data, onChange, validation) => (
                        <fieldset className='space-y-4'>
                            <div className="flex space-x-4 flex-row">
                                <div className='flex-1 space-y-8'>
                                    <div>
                                        <TextArea
                                            id="message"
                                            label="Post"
                                            value={data.message}
                                            onChange={onChange('message')}
                                            error={validation.hasErrors('message')}
                                            help={validation.getErrors('message')}
                                        />
                                    </div>

                                    <AttachedImages
                                        media={media}
                                        onAdd={this.onAddPostMedia}
                                        onRemove={this.onRemovePostMedia}
                                    />
                                </div>
                            </div>
                        </fieldset>
                    )}
                </Form>
            </Modal.Content>
            <Modal.Footer>
                <Button form='post-editor' type='primary' busy={this.state.busy}>Update</Button>
                <Button onClick={this.onClose}>Cancel</Button>
            </Modal.Footer>
        </Modal>;



    }
}

function remapMediaSrcProperty(media) {
    console.log('remapMediaSrcProperty', media);

    if (typeof media === 'string' || media instanceof String) {
        media = JSON.parse(media);
    }

    return media.map(item => ({
        ...item,
        src: item.filename // yeah, this is the url... :(
    }))
}
